<style scoped>
.reset-container {
	max-width: 500px;
	margin: 0 auto;
}
.reset-box {
	box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
	border-radius: 10px;
	overflow: hidden;
	padding: 40px;
}
.reset-header {
	margin-bottom: 25px;
	text-align: center;
}
</style>

<template>
	<div
		class="container min-vh-100 d-flex align-items-center justify-content-center py-5"
	>
		<div class="reset-container">
			<div class="reset-box">
				<div class="reset-header">
					<h2>Set New Password</h2>
					<p class="text-muted">Enter your new password below</p>
				</div>

				<div v-if="!success">
					<div v-if="error" class="alert alert-danger" role="alert">
						{{ error }}
					</div>

					<form @submit.prevent="handleSubmit">
						<div class="mb-3">
							<label for="new_password" class="form-label">New Password</label>
							<input
								type="password"
								class="form-control"
								id="new_password"
								v-model="newPassword"
								required
								minlength="8"
								:disabled="loading"
							/>
							<div class="form-text">Password must be at least 8 characters.</div>
						</div>

						<div class="mb-3">
							<label for="confirm_password" class="form-label">Confirm Password</label>
							<input
								type="password"
								class="form-control"
								id="confirm_password"
								v-model="confirmPassword"
								required
								minlength="8"
								:disabled="loading"
							/>
						</div>

						<div class="d-grid gap-2">
							<ButtonLoading
								:loading="loading"
								text="Reset Password"
								variant="primary"
								type="submit"
							/>
						</div>
					</form>
				</div>

				<div v-else>
					<div class="alert alert-success" role="alert">
						Your password has been reset successfully!
					</div>
					<div class="text-center mt-3">
						<RouterLink to="/signin" class="btn btn-primary">Go to Login</RouterLink>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useRoute } from "vue-router";
import { apiClient } from "@/client";
import ButtonLoading from "@/components/common/ButtonLoading.vue";

const route = useRoute();
const uuid = ref(route.params.uuid as string);
const email = ref(decodeURIComponent(route.params.email as string));
const newPassword = ref("");
const confirmPassword = ref("");
const loading = ref(false);
const error = ref("");
const success = ref(false);

async function handleSubmit() {
	if (!newPassword.value) {
		error.value = "Please enter a new password.";
		return;
	}
	if (newPassword.value.length < 8) {
		error.value = "Password must be at least 8 characters.";
		return;
	}
	if (newPassword.value !== confirmPassword.value) {
		error.value = "Passwords do not match.";
		return;
	}

	loading.value = true;
	error.value = "";

	try {
		await apiClient.JSONPost("/api/password-reset/use", {
			uuid: uuid.value,
			email: email.value,
			new_password: newPassword.value,
		});
		success.value = true;
	} catch (e: any) {
		error.value = e?.message || "Invalid or expired reset request.";
	} finally {
		loading.value = false;
	}
}
</script>
